import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-9 d-flex align-items-center" }
const _hoisted_2 = { class: "col-3" }
const _hoisted_3 = { class: "row mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_three_dot_menu = _resolveComponent("three-dot-menu")!
  const _component_empty_asset = _resolveComponent("empty-asset")!
  const _component_add_asset = _resolveComponent("add-asset")!
  const _component_sub_section = _resolveComponent("sub-section")!
  const _component_final_salary_editor = _resolveComponent("final-salary-editor")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_sub_section, {
      title: _ctx.listHeaderText,
      helpTitle: "Your final salary pensions",
      helpText: _ctx.HelpText.finalSalary()
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFinalSalaries, (finalSalary) => {
          return (_openBlock(), _createElementBlock("div", {
            key: finalSalary.id,
            class: "row mb-2"
          }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(finalSalary.description), 1),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_three_dot_menu, {
                id: finalSalary.id,
                permissions: _ctx.getPermissionSet(),
                onEditClicked: _ctx.onEdit,
                onDeleteClicked: _ctx.onDelete
              }, null, 8, ["id", "permissions", "onEditClicked", "onDeleteClicked"])
            ])
          ]))
        }), 128)),
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_empty_asset, { name: "final salary pensions" })
        ], 512), [
          [_vShow, !_ctx.hasFinalSalaries]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_add_asset, {
            name: "pension",
            longName: "another final salary pension",
            onAddClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAdd()))
          })
        ])
      ]),
      _: 1
    }, 8, ["title", "helpText"]),
    _createVNode(_component_modal, {
      title: _ctx.modalTitle,
      ref: "assetModal",
      idKey: "finalSalary"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_final_salary_editor, {
          ref: "assetEditor",
          onEditFinished: _ctx.onEditFinished
        }, null, 8, ["onEditFinished"])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}